import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IconComponent } from '@kin/spark-ui';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent {
  private router = inject(Router);
  private auth = inject(AuthService);

  get isAdmin(): boolean {
    return this.auth.isAdmin();
  }

  goToAdmin() {
    this.router.navigate(['/admin']);
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }
}
